import React, { useState, useEffect } from 'react';
import { Blurhash } from 'react-blurhash'; // Import Blurhash
import belantaraimg from '../../../../src/assets/discover/belantara.webp';
import sindhudurgimg from '../../../../src/assets/discover/sindudurg.jpg';
import { Link } from 'react-router-dom';
import './Discoversect.css';
import { getTable } from '../../../config/seatable';

function Discoversect() {
  const [belantaraLoaded, setBelantaraLoaded] = useState(false);
  const [ discoverImages, setDiscovserImages] = useState([])
  useEffect(() => {
    const img = new Image(); // Use Image constructor (case-sensitive)
    img.onload = () => {
      setBelantaraLoaded(true);
    };
    img.src = belantaraimg; // Set the source
  }, []);

  useEffect(()=>{
    const fetchdiscoverImg = async () =>{
         try
         {
          const fetchedImg =  await getTable("Discover")
          setDiscovserImages(fetchedImg.rows)
          console.log("fetched discover images are:", discoverImages);  
         }
         catch(err)
         {
          console.log("error fetching Discover images", err);     
         }
    }
    fetchdiscoverImg()
  }, [])
  return (
    <>
      <section className="discover px-md-5 px-3 pt-3" id="Discoversect">
        <h3 className="section-heading pt-5 pb-md-4 pb-0 text-center">Hidden Gem</h3>
        <div className="row g-md-5 g-3 pb-5 px-md-5 px-3 discovery-box">
          {
            discoverImages.map((item)=>{
              const imgurl = item["abTr"]
              return
              {
                <img src={imgurl} alt='test' />
              }
            })
          }
          <div className="col-lg-8 col-md-6 discover-div pt-5 mt-0">
            {!belantaraLoaded && (
              <Blurhash
                hash="LdBXH7-SadWUL4Rjf6j[cFW?oMWW" // Ensure this is the correct BlurHash for belantaraimg
                width="100%"
                height="100%"
                resolutionX={32}
                resolutionY={32}
                punch={1}
              />
            )}
            {belantaraLoaded && (
              <img src={belantaraimg} alt="Belantara private beach estate" className="img-fluid belantara-img" />
            )}
            <p className="text-style discover-text text-white text-start mt-4">
              Unwind yourself in the lap of luxury with our exquisitely designed villa and cottages nestled near a rocky beach,
              under the coconut trees. Belantara is a private beach estate especially designed for those who want privacy and peace
              from the hustle and bustle of the world. The stunning view of an enchanting ocean and the constant sound of waves crashing
              over the rocks is the popular attraction of Belantara.
              <p className="mt-3">
                <Link to="discover" className="link-style text-decoration-none">
                  See more
                </Link>
              </p>
            </p>
          </div>
          <div className="col-lg-4 col-md-6 discover-div pt-5 mt-0">
            <img
              src={sindhudurgimg}
              alt="Sindhudurg Fort"
              className="img-fluid sindhudurg-img"
              loading="lazy"
            />
            <p className="text-style discover-text text-white text-start mt-4">
              Sindhudurg is India's hidden gem in coastal southern Maharashtra bordering North Goa. It is the first district in
              Maharashtra to be declared as a tourism district.
              <p className="mt-3">
                <Link to="/discover#pagetop" className="link-style text-decoration-none">
                  See more
                </Link>
              </p>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Discoversect;
